<template>
  <div class='container-fluid'>
    <h1 class='text-center'>Users page</h1>
    <div class="row" v-if="users">Users {{users.count}}</div>
    <ul>
      <li v-for="user in users" :key='user.id'>{{user.email}}</li>
    </ul>
    <div class='row justify-content-md-center'>
      <div class="col-md-4 cold-md-offset-4">
        <h4> Logged in as {{ currentUser.email }} </h4>
        <router-link to="/boards">Homepage</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Users',
  data () {
    return {
      users: []
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },

  created () {
    this.all_users()
  },

  methods: {
    all_users () {
      if (process.env.USE_SSO === false) {
        this.users = [
          {email: 'test@webstreak.com'},
          {email: 'fake_email@webstreak.com'}
        ]
      } else {
        this.$http.get('/users', { headers: { 'Authorization': 'Bearer ' + localStorage.token } })
          .then(response => this.showUsers(response))
          .catch((e) => this.error(e))
      }
    },

    showUsers (response) {
      this.users = response.data
    },

    error (e) {
      console.log(e)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Users.vue